import * as React from 'react';
import { Table } from 'antd';
import dayjs from 'dayjs';

type CertificateTableProps = {
  certificates: Object[] | [];
};

export default function CertificatesTable(props: CertificateTableProps) {
  const [certificates, setCertificates] = React.useState([]);

  React.useEffect(() => {
    let notExpiredCertificates: any = [];

    props.certificates.map((certificate: any) => {
      if (!dayjs().isAfter(dayjs(certificate.expiryDate))) {
        notExpiredCertificates.push(certificate);
      }
    });

    setCertificates(notExpiredCertificates);
  }, [props.certificates]);

  const columns: Object[] = [
    {
      title: 'Certificate',
      dataIndex: 'certificateName',
      render: (text: string, record: any) => {
        // if (dayjs().isAfter(dayjs(record.expiryDate))) {
        //   return <p className="expired">{text}</p>;
        // } else {
        return <p className="valid">{text}</p>;
        // }
      },
    },
    {
      title: 'Valid Until',
      dataIndex: 'expiryDate',
      render: (text: string, record: any) => {
        // If certificate is expired, display it in red
        // if (dayjs().isAfter(dayjs(text))) {
        //   return <p className="expired">{dayjs(text).format('MMM DD, YYYY')}</p>;
        // } else {
        return <p className="valid">{dayjs(text).format('MMM DD, YYYY')}</p>;
        // }
      },
    },
    {
      title: 'Certificate Number',
      dataIndex: 'certificateNumber',
    },
  ];

  return <Table columns={columns} dataSource={certificates} rowKey="_id" />;
}
